import { Helmet } from 'react-helmet'
import MainHeader from '../../components/MainHeader/MainHeader.js'
import MainFooter from '../../components/MainFooter/MainFooter.js'

import './Barrierefreiheit.css'
import './MBarrierefreiheit.css'


export default function Barrierefreiheit() {

    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={""} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Barrierefreiheit</title>
                <meta property="og:title" content="Barrierefreiheit" />
                <meta property="og:description" content="Hier findest du unsere Erklärung zur Barrierefreiheit" />
            </Helmet>
            <section className='sec_next' id='sec_next--barrierefreiheit'>
                <div className='sec_next_cont' id="sec_next--barrierefreiheit--cont" style={{ wordBreak: "break-word" }}>

                    <h2>Erklärung zur Barrierefreiheit</h2>
                    <h3>1. Gültigkeit</h3>
                    <p>Die it.liepert.gmbh ist bemüht, ihre Website <a href="https://liepert.de">https://liepert.de</a> barrierefrei zugänglich zu machen. Grundlage hierfür ist das Barrierefreiheitsstärkungsgesetz (BFSG) in Verbindung mit der Barrierefreiheitsverordnung (BFV).<br />
                        Diese Erklärung zur Barrierefreiheit gilt für die Website: <a href="https://liepert.de">liepert.de</a>, <a href="http://it.liepert.gmbh">it.liepert.gmbh</a>, <a href="http://liepert.gmbh">liepert.gmbh</a> und <a href="http://it-liepert.de">it-liepert.de</a></p>

                    <h3>2. Stand der Vereinbarkeit mit den Anforderungen</h3>
                    <p>Diese Website ist teilweise vereinbar mit den Anforderungen der EN 301 549 V3.2.1 (2021-03) sowie der Web Content Accessibility Guidelines (WCAG) 2.1 auf Konformitätsstufe AA.</p>
                    <p>Zur Verbesserung der Barrierefreiheit nutzen wir das <a href='https://accessibility-widget.pages.dev/' target='_blank'>Accessibility Widget Sienna</a>, das über das Icon unten Links aufgerufen werden kann.</p>
                    <p>Die Bewertung der Barrierefreiheit beruht auf einer Selbstbewertung vom 25. Juni 2025.</p>

                    <h3>3. Nicht barrierefreie Inhalte</h3>
                    <p>Trotz unserer Bemühungen sind folgende Inhalte derzeit nicht vollständig barrierefrei:</p>
                    <ul>
                        <li><strong>Lesbarkeit der Texte </strong> ist teilweise durch schwachen Kontrast, bedingt durch die Farbgebung, eingeschränkt. Um dem entgegenzuwirken haben wir bei betroffenen Texten einen Textschatten hinzugefügt. Als weitere Gegenmaßnahme kann das Sienna Accessibility Widget (Icon unten links) genutzt werden.</li>
                    </ul>
                    <p>Wir arbeiten kontinuierlich daran, diese Inhalte barrierefrei bereitzustellen.</p>

                    <h3>4. Verpflichtende Umsetzung</h3>
                    <p>Die it.liepert.gmbh ist gemäß § 3 Abs. 3 BFSG zur Einhaltung der gesetzlichen Barrierefreiheitsanforderungen verpflichtet, da sie mehr als zehn Beschäftigte hat. Unabhängig davon verfolgen wir das Ziel, unsere Website so barrierefrei wie möglich zu gestalten – als Ausdruck unseres Verständnisses von digitaler Teilhabe und Verantwortung.</p>


                    <h3>5. Feedback und Kontakt</h3>
                    <p>Sollten Ihnen Barrieren auf unserer Website auffallen oder möchten Sie Informationen in barrierefreier Form anfordern, kontaktieren Sie uns bitte:</p>
                    <p>
                        📧 E-Mail: <a href="mailto:info@liepert.de?subject=Barrierefreiheit">info@liepert.de</a><br />
                        📞 Telefon: <a href='tel:0833196700'>08331 9670 0</a><br />
                        📬 Adresse: it.liepert.gmbh, Zeissweg 4, 87700 Memmingen<br />
                    </p>

                    <h3>6. Schlichtungsverfahren</h3>
                    <p>Wenn Sie der Ansicht sind, dass Sie durch eine nicht ausreichende barrierefreie Gestaltung unserer Website benachteiligt sind, können Sie sich an die Schlichtungsstelle BGG wenden:</p>
                    <p>
                        <strong>Schlichtungsstelle BGG</strong><br />
                        bei der Beauftragten der Bundesregierung für die Belange von Menschen mit Behinderungen<br />
                        Mauerstraße 53, 10117 Berlin<br />
                        📧 E-Mail: <a href="mailto:info@schlichtungsstelle-bgg.de">info@schlichtungsstelle-bgg.de</a><br />
                        🌐 <a href="https://www.schlichtungsstelle-bgg.de" target="_blank">www.schlichtungsstelle-bgg.de</a>
                    </p>

                    <h3>7. Stand dieser Erklärung</h3>
                    <p>Diese Erklärung wurde am 25.06.2025 erstellt. Letzte Überprüfung siehe oben.</p>

                </div>
            </section >

            <MainFooter />
        </div >
    )
}